"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Customer = void 0;
const common_1 = require("../../common");
const partner_address_model_1 = require("./partner-address.model");
class Customer extends common_1.MongoSubDocument {
}
exports.Customer = Customer;
//# sourceMappingURL=customer.model.js.map